module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAkCAYAAAAq23xmAAAAvElEQVRoge3ZQQ6EIBAFUTDeDI7N3Zi4Y6FWHBMBrbefhPx0j00TU0o1zCGWUh4/6DJJON0YEFi30h36hJ3FWmf5C+rDFgMGBAwIGBAwILBe/UHO+ekzdmUFgcsV1PjEAGUFAQMCd1rsE3c472LAFgMGBAwIGBAwILC9agx1oB4vF2esINAOiiMMRMMNn1YQMCDQtpjvYzu8iwFbDBgQ+Gsf9MbF/dGAagWBOxvF8KLF/eEX3AoCBnQmhPADE8oXE/mPm/wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/newsCenter/more_b.png
// module id = QKtI
// module chunks = 0